import { postController } from '@/controllers/request';
import { MODULE } from '@/utils/constants';
import { getTableData } from '@/utils/helpers';

export default {
  namespaced: true,
  state: {
    attachingCandidates: false,
    popupList: [],
    popupPageConfig: {},
    metadataFields: [],
    baseParams: {},
    requestSent: false
  },
  mutations: {
    popupPageConfig(state, config) {
      state.popupPageConfig = config;
    },
    setBaseParams(state, params = {}) {
      state.baseParams = params;
    },
    setAttachingCandidates(state, value) {
      state.attachingCandidates = value;
    },
    setPopupData(state, { data, sugarconfig, mod, replace }) {
      if (replace) state.popupList = getTableData(data, sugarconfig, mod);
      else state.popupList.push(...getTableData(data, sugarconfig, mod));
    },
    setMetadataFields(state, sugarconfig = {}) {
      state.metadataFields = Object.values(sugarconfig)
        .filter(
          param =>
            param.hasOwnProperty('metadata_sort') &&
            !param.hasOwnProperty('visibility') &&
            param.visibility !== 'hidden'
        )
        .sort((a, b) => a.metadata_sort - b.metadata_sort)
        .map(({ name }) => name.toLowerCase());
    },
    setRequestStatus(state, val) {
      state.requestSent = val;
    }
  },
  actions: {
    async loadPopupData(
      { commit, rootState },
      { params /*updateFilterParams = true, replace*/ }
    ) {
      let isCoordRequest = false;
      if (params?.isCoordRequest) {
        isCoordRequest = true;
        params.displayMode = 'spa';
        delete params.isCoordRequest;
      }

      //TODO: перенести логику в отдельный модуль
      const formData = new FormData();

      for (let key in params) {
        if (Array.isArray(params[key])) {
          params[key].forEach(val => formData.append(key + '[]', val));
        } else if (key == 'module' && params.module == 'vacancy_candidates') {
          formData.set(key, MODULE.CANDIDATES_MODULE);
          let stages = rootState.rightPanel?.stages?.filter(
            stage => !stage.state
          );
          if (stages) {
            stages.forEach(stage => {
              formData.append('hidden_stage_ids[]', stage.id);
            });
          }
        } else if (typeof params[key] === 'object') {
          Object.values(params[key]).forEach(val =>
            formData.append(key + '[]', val)
          );
        } else {
          formData.set(key, params[key]);
        }
      }

      try {
        commit('setRequestStatus', true);
        const request = await postController({
          options: formData,
          params: {
            headers: {
              Accept: 'application/json',
              'Content-Type': 'multipart/form-data'
            }
            // params: {
            //   module: params.search_module || params.module,
            //   action: params.action
            // }
          }
        });

        if (!request.data || typeof request.data == 'string') {
          return;
        }

        if (isCoordRequest) {
          params.module = MODULE.COORDINATION_REQUEST;
        }

        commit(
          'common/setTableData',
          {
            module:
              params.module == MODULE.CANDIDATE_RESPONDS
                ? 'vacancy_responds'
                : params.module,
            columns: request.data.metadata
              ? request.data.metadata.data.data.title
              : request.data.data.data.data.title,
            rows: request.data.metadata
              ? request.data.metadata.data.data.rows
              : request.data.data.data.data.rows,
            replace: false
          },
          { root: true }
        );

        commit(
          'common/setParam',
          {
            name: 'tableFields',
            val: request.data?.metadata
              ? request.data.metadata.sugarconfig
              : request?.data?.sugarconfig
          },
          {
            root: true
          }
        );

        commit(
          'setMetadataFields',
          request.data?.metadata
            ? request.data.metadata.sugarconfig
            : request.data.sugarconfig
        );

        commit(
          'popupPageConfig',
          request.data?.metadata
            ? request.data.metadata.pageData
            : request.data.data.pageData
        );

        commit(
          'filters/setFiltersConfig',
          request.data?.metadata
            ? request.data.metadata.custom_search
            : request.data.custom_search,
          {
            root: true
          }
        );

        commit(
          'filters/setParam',
          {
            name: 'sortActive',
            val: !request.data?.custom_search?.sortable?.default || false
          },
          { root: true }
        );

        if (params.module == MODULE.CANDIDATES_MODULE) {
          commit('candidate/setCandidateListData', request.data, {
            root: true
          });
        } else if (params.module === MODULE.COORDINATION_REQUEST) {
          commit(
            'coordinationRequest/setParam',
            {
              name: 'metadata',
              val: request.data
            },
            { root: true }
          );
        }
      } catch (e) {
        console.error(e);
      } finally {
        commit('setRequestStatus', false);
      }
    }
  }
};
